import React from 'react'

const AutomationOptionsIfttt = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" className={className}>
    <path
      d="M40.86 1H7.32C3.82956 1 1 3.82956 1 7.32V40.86C1 44.3504 3.82956 47.18 7.32 47.18H40.86C44.3504 47.18 47.18 44.3504 47.18 40.86V7.32C47.18 3.82956 44.3504 1 40.86 1Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M10.3698 19.72H7.58984V28.47H10.3698V19.72Z" fill="black" />
    <path d="M11.5605 19.72V22.5V23.29V26.08V28.46H14.3505V26.08H16.7305V23.29H14.3505V22.5H17.9305V19.72H14.3505H11.5605Z" fill="black" />
    <path d="M20.7107 19.72H18.7207V22.5H20.7107V28.46H23.4907V22.5H25.4807V19.72H23.4907H20.7107Z" fill="black" />
    <path d="M28.2593 19.72H26.2793V22.5H28.2593V28.46H31.0493V22.5H33.0293V19.72H31.0493H28.2593Z" fill="black" />
    <path d="M38.6001 19.72H35.8201H33.8301V22.5H35.8201V28.46H38.6001V22.5H40.5901V19.72H38.6001Z" fill="black" />
  </svg>
)

export default AutomationOptionsIfttt
